import React from "react";
import { Button } from "antd";

const getStatusProps = (shop) => {
  let { isPublishByApprover, isPublishByMerchant } = shop;
  return isPublishByMerchant && isPublishByApprover
    ? {
        text: "Published",
        color: "var(--ion-color-green-600)",
        background: "var(--ion-color-green-100)",
      }
    : {
        text: "Unpublished",
        color: "var(--ion-color-step-600)",
        background: "var(--ion-color-step-100)",
      };
};

const Status = ({ shop }) => {
  if (!shop) {
    return null;
  }

  const { text, color, background } = getStatusProps(shop);

  return (
    <Button
      type="text"
      style={{
        fontSize: "1rem",
        color: color,
        background: background,
      }}
    >
      {text}
    </Button>
  );
};

export default Status;
